import { useNavigate } from "react-router-dom";
import { IdCard, UserRound, FileText, Megaphone, CalendarDays, Users2, Settings, Lock, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const MENU = [
  { to: "/app/kad", label: "Kad Ahli Digital", icon: IdCard },
  { to: "/app/profil", label: "Profil Saya", icon: UserRound },
  { to: "/app/status", label: "Status Keahlian", icon: FileText },
  { to: "/app/dokumen", label: "Dokumen Saya", icon: FileText },
  { to: "/app/pengumuman", label: "Pengumuman", icon: Megaphone },
  { to: "/app/program", label: "Program", icon: CalendarDays },
  { to: "/app/jawatankuasa", label: "Jawatankuasa", icon: Users2 },
  { to: "/app/tetapan", label: "Tetapan", icon: Settings },
];
const FUTURE_MENU = ["Kerja", "Kehadiran", "Latihan", "Sijil", "Yuran"];

export default function MenuMobile() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <div className="p-5" data-testid="mobile-menu-page">
      <h1 className="font-display text-xl font-bold text-piks-black mb-5">Menu</h1>
      <div className="space-y-2">
        {MENU.map((m) => (
          <button key={m.to} onClick={() => navigate(m.to)} data-testid={`mobile-menu-${m.label.toLowerCase().replace(/\s/g, "-")}`} className="flex items-center gap-3 w-full p-4 rounded-lg bg-white border border-piks-border text-left">
            <m.icon className="w-4.5 h-4.5 text-piks-black" />
            <span className="text-sm font-medium text-piks-black">{m.label}</span>
          </button>
        ))}
        {FUTURE_MENU.map((f) => (
          <div key={f} className="flex items-center justify-between p-4 rounded-lg bg-piks-ivory border border-dashed border-piks-border text-piks-muted">
            <span className="text-sm">{f}</span>
            <span className="flex items-center gap-1 text-[10px] font-semibold"><Lock className="w-3 h-3" /> AKAN DATANG</span>
          </div>
        ))}
        <button onClick={async () => { await logout(); navigate("/"); }} data-testid="mobile-menu-logout-btn" className="flex items-center gap-3 w-full p-4 rounded-lg bg-piks-black text-white mt-4">
          <LogOut className="w-4 h-4" /> <span className="text-sm font-medium">Log Keluar</span>
        </button>
      </div>
    </div>
  );
}
